import { useTranslation } from 'react-i18next';
import { useState } from 'react';
import {
    VStack,
    HStack,
    Text,
    Input,
    Button,
    Box,
} from '@chakra-ui/react';
import { useAppStore } from '../../state/store';
import { ManageDialogFrame, ManageDialogCloseFooter, ManageDialogPrimaryButton } from './ManageDialogFrame';
import { useBIMStore } from '../../state/useBIMStore';

function notify(message: string) {
    window.dispatchEvent(new CustomEvent('yap:notify', { detail: { message } }));
}

export function IDSelectionDialog() {
    const { t } = useTranslation();
    const isOpen = useAppStore((state) => state.manageDialog === 'idSelection');
    const onClose = useAppStore((state) => state.closeManageDialog);
    const project = useBIMStore((state) => state.project);
    const setSelection = useBIMStore((state) =>state.setSelection); const [query, setQuery] = useState(''); const [error, setError] = useState<string | null>(null);

    const handleSelect = () => {
        const raw = query.trim();
        if (!raw) return;

        const element = project.elements.get(raw)
            ?? Array.from(project.elements.values()).find(
                (el) => String(el.numericId) === raw
            );

        if (!element) {
            setError(`No element found with ID "${raw}".`);
            return;
        }

        setSelection([element.id]);
        setError(null);
        const label = element.name ?? `${element.category} ${element.numericId ?? ''}`.trim();
        notify(`Selected element: ${label}`);
        onClose();
    };

    const handleClose = () => {
        setQuery('');
        setError(null);
        onClose();
    };

    return (
        <ManageDialogFrame
            title={t('manage.selectByID')}
            isOpen={isOpen}
            onClose={handleClose}
            size="sm"
            footer={
                <ManageDialogCloseFooter
                    onClose={handleClose}
                    extra={
                        <ManageDialogPrimaryButton
                            label={t('manage.select')}
                            onClick={handleSelect}
                            isDisabled={!query.trim()}
                        />
                    }
                />
            }
        >
            <VStack spacing={3} align="stretch">
                <Text fontSize="xs" color="var(--color-text-secondary)">{t('manage.enterTheElementIDGUIDOrTheNumericIDToSelectItInTheCurrentView')}</Text>
                <Input
                    size="sm"
                    placeholder={t('manage.elementIDOrNumericID')}
                    value={query}
                    onChange={(e) => {
                        setQuery(e.target.value);
                        setError(null);
                    }}
                    onKeyDown={(e) => {
                        if (e.key === 'Enter') handleSelect();
                    }}
                    bg="var(--color-bg-tertiary)"
                    borderColor="var(--color-border)"
                    autoFocus
                />
                {error ? (
                    <Box
                        p={2}
                        borderRadius="var(--cad-radius-sm)"
                        bg="var(--color-bg-tertiary)"
                        borderWidth="1px"
                        borderColor="var(--color-status-error, #e5484d)"
                    >
                        <Text fontSize="xs" color="var(--color-status-error, #e5484d)">
                            {error}
                        </Text>
                    </Box>
                ) : null}
                <HStack spacing={2}>
                    <Text fontSize="xs" color="var(--color-text-secondary)">{t('manage.tipNumericIDsAreShownAsElementIDInThePropertiesPalette')}</Text>
                </HStack>
            </VStack>
        </ManageDialogFrame>
    );
}
